<template>
  <div>
    <h3 class="mb-5">Job Information</h3>
    <div class="h4 mb-5">顯示於Carrer Page頁面</div>
    <div>
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <h4 class="w-180px">Title</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ career.job.title }}
        </div>
      </div>
      <!-- SubTitle -->
      <div class="form-item d-flex py-5">
        <h4 class="w-180px">SubTitle</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ career.job.subtitle }}
        </div>
      </div>
      <!-- Call To Action -->
      <div class="form-item d-flex py-5">
        <h4 class="w-180px">Call To Action</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ career.job.call_to_action }}
        </div>
      </div>
      <!-- 導連網址 -->
      <div class="form-item d-flex py-5 mx-30px">
        <h4 class="w-180px">導連網址</h4>
        <div class="flex-grow-1 flex-basis-0">
          <a href="https://www.104.com.tw/company/5wp49rs" class="text-decoration-none">
            {{ career.job.url }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    career: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
